module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-flex', [_vm._v("\n        " + _vm._s(_vm.$t('logs.historical')) + ". "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$t('logs.historicalsubtitle')))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Search",
      "append-icon": "search",
      "clearable": ""
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }), _vm._v(" "), (_vm.treatmentLogsRequest.loading) ? _c('v-progress-circular', {
    attrs: {
      "color": "amber",
      "size": "20",
      "width": "2",
      "indeterminate": ""
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-timeline', {
    staticClass: "mb-4 ml-3",
    attrs: {
      "dense": "",
      "clipped": ""
    }
  }, [(_vm.searchString && _vm.searchString.length > 0) ? _c('v-timeline-item', {
    staticClass: "subheading",
    attrs: {
      "hide-dot": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('logs.searchinfo', {
    string: _vm.searchString
  })) + "\n      ")]) : _c('v-timeline-item', {
    staticClass: "subheading",
    attrs: {
      "hide-dot": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$tc('logs.summary', _vm.historicalTreatmentLogs.length, {
    n: _vm.historicalTreatmentLogs.length,
    from: _vm.oldestAppointmentDate
  }))), _c('br'), _vm._v(" "), (_vm.historicalTreatmentLogs.length > 0) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.$t('logs.lastseen', {
    date: _vm.mostRecentAppointmentDate
  })) + "\n        ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.filteredHistoricalTreatmentLogs), function(log, index) {
    return [(_vm.isNewDate(log, index, _vm.filteredHistoricalTreatmentLogs)) ? _c('v-timeline-item', {
      key: ("dt-" + index),
      staticClass: "mt-3"
    }, [_c('template', {
      slot: "icon"
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "small": ""
      }
    }, [_vm._v("event")])], 1), _vm._v(" "), _c('span', {
      staticClass: "subheading"
    }, [_vm._v(_vm._s(_vm.luxonDateformat(log.last_used, 'ccc d MMM yyyy')))])], 2) : _vm._e(), _vm._v(" "), _c('v-timeline-item', {
      key: index,
      staticClass: "mb-0",
      attrs: {
        "small": "",
        "color": "pink",
        "icon-color": "grey lighten-2"
      }
    }, [_c('v-layout', {
      attrs: {
        "justify-space-between": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs7": ""
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(log.code))]), _vm._v(" "), _vm._v("\n                " + _vm._s(_vm.$tc('logs.count', log.count, {
      n: log.count
    })) + "\n              ")]), _vm._v(" "), (log.count > 1) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.luxonDateformat(log.first_used, 'ccc d MMM yyyy')) + " -\n                " + _vm._s(_vm.luxonDateformat(log.last_used, 'ccc d MMM yyyy')) + "\n              ")]) : _c('div', [_vm._v("\n                " + _vm._s(_vm.luxonDateformat(log.first_used, 'ccc d MMM yyyy')) + "\n              ")])])], 1)], 1)]
  }), _vm._v(" "), (!_vm.treatmentLogsRequest.loading) ? [(_vm.historicalTreatmentLogs && _vm.historicalTreatmentLogs.length === 0) ? _c('v-timeline-item', [_vm._v("\n          " + _vm._s(_vm.$t('zeroresults')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.historicalTreatmentLogs.length > 0 && _vm.filteredHistoricalTreatmentLogs && _vm.filteredHistoricalTreatmentLogs.length === 0) ? _c('v-timeline-item', [_vm._v("\n          " + _vm._s(_vm.$t('zerosearchresults')) + "\n        ")]) : _vm._e()] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4ba1c6e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/codes/HistoricalUsage.vue
// module id = 1520
// module chunks = 9